module.exports = __webpack_public_path__ + "img/eq-wolf-head.a69aa187.png";